// Le baromètre d'adoption, au tableau de bord : lancer une vague, retrouver les
// précédentes. Les questions dépendent du modèle du produit, choisi à l'état des
// lieux ; le détail de chaque vague vit sur sa fiche d'étude.
import { ApiRequestError } from '../api/client';
import { useProductContext } from '../api/queries';
import { Button, Chip, ErrorBanner, Eyebrow, Note, buttonClass } from '../components/ui';
import { Link, hrefFor } from '../router';
import { useStartWave, useWaves } from '../studies/questionnaire';
import { useCanWrite } from '../write/useCanWrite';

const day = (iso: string) => new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });

export function BarometerBlock({ projectId }: { projectId: string }) {
  const waves = useWaves(projectId);
  const context = useProductContext(projectId);
  const start = useStartWave(projectId);
  const canWrite = useCanWrite(projectId);

  if (waves.isPending || waves.isError) return null;
  const list = waves.data.waves;
  const open = list.some((w) => !w.closedAt);
  const model = context.data?.product.pillarModel ?? null;
  const base = `/projet/${encodeURIComponent(projectId)}/etudes`;
  const link = start.data ? `${window.location.origin}${hrefFor(`/q/${start.data.token}`)}` : null;

  return (
    <section className="metrics measures">
      <div className="metrics-head">
        <Eyebrow>Baromètre</Eyebrow>
        <h2 className="t-h2">Baromètre d’adoption</h2>
        <span className="t-mono">NPS, SUS et piliers de votre modèle</span>
        {canWrite && !open ? (
          <Button variant="accent" loading={start.isPending} disabled={!model} onClick={() => start.mutate()}>
            Lancer un baromètre
          </Button>
        ) : null}
      </div>

      {!model ? (
        <Note tone="lecture">Choisissez d’abord le type de produit et à qui il s’adresse, dans l’état des lieux.</Note>
      ) : null}
      {start.error ? <ErrorBanner>{start.error instanceof ApiRequestError ? start.error.message : 'Le lancement a échoué.'}</ErrorBanner> : null}
      {link ? (
        <Note tone="succes" role="status">
          Vague lancée. Lien à partager, qui ne s’affichera qu’une fois : {link}
        </Note>
      ) : null}

      {list.length > 0 ? (
        <ul className="qr-list">
          {list.map((w) => (
            <li key={w.id}>
              <span>
                <strong>{w.title}</strong>
                <span className="inv-sub">{day(w.createdAt)}, {w.respondents} réponse{w.respondents > 1 ? 's' : ''}</span>
              </span>
              <Chip state={w.closedAt ? 'succes' : undefined}>{w.closedAt ? 'Close' : 'En cours'}</Chip>
              <Link to={`${base}/${encodeURIComponent(w.id)}`} className={buttonClass('ghost')}>
                Ouvrir
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
